// 获取操作系统名称
const getPlatformName = (platform) => {
  if (platform == 1 || platform === 'android') return 'Android';
  if (platform == 2 || platform === 'ios') return 'iOS';
  return '-';
}

export default getPlatformName;